import Category from '@/models/Category';
import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { OnboardState, OnboardTypes } from './types';

const INITIAL_STATE: OnboardState = {
    data: { categories: [] as Category[] },
    loading: false,
    hasError: false,
};

const reducer: Reducer<OnboardState> = (state: OnboardState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case OnboardTypes.COMPLETE_ONBOARD_REQUEST:
            return { ...state, loading: true, hasError: false };
        case OnboardTypes.COMPLETE_ONBOARD_SUCCESS:
            return { ...state, loading: false, hasError: false };
        case OnboardTypes.COMPLETE_ONBOARD_FAILURE:
            return { ...state, loading: false, hasError: true };
        default:
            return state;
    }
};

export default reducer;
